module.exports = __webpack_public_path__ + "static/2.0e4a31fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BSc/2.png
// module id = 820
// module chunks = 93830084423213 241891719824365